import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, signInAnonymously, onAuthStateChanged } from 'firebase/auth';
import { useState, useEffect } from 'react'
import { firebaseConfig } from '../firebaseConfig';

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const analytics = getAnalytics(app);
const auth = getAuth(app);

// Sign in anonymously once at module load
if (!auth.currentUser) {
    signInAnonymously(auth).catch((error) => {
        console.error('Anonymous sign-in failed:', error);
    });
}

const useFirebase = () => {
    const [authReady, setAuthReady] = useState(!!auth.currentUser);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            setAuthReady(!!user);
        });
        return unsubscribe;
    }, []);

    return { db, analytics, authReady }
}

export default useFirebase
